// extracted by mini-css-extract-plugin
export default {"backButton":"BackButton_backButton__0XyS+","backButtonIcon":"BackButton_backButtonIcon__T-zhW","hoverUnderlineAnimation":"BackButton_hoverUnderlineAnimation__8AkdG"};